import { useEffect, useRef, useState } from "react";
import { load } from "js-yaml";
import Member from "./Member";
import "./Members.css";
import { nanoid } from "nanoid";
import { useStore } from "../store";

export default function Members(props) {
  const setAlertMessage = useStore((state) => state.setAlertMsg);
  const members = useStore((state) => state.members);
  const visibility = useStore((state) => state.resultVisible);
  const setVisibility = useStore((state) => state.setResultVisible);
  const query = useStore((state) => state.query);
  const setQuery = useStore((state) => state.setQuery);
  /**
   * vertical scroll to horizontal scroll
   * @param {*} e
   */
  const onWheel = (e) => {
    e.preventDefault();
    e.target.scrollLeft += e.deltaY;
  };

  const onWheelChild = (e) => {
    e.preventDefault();
    e.target.scrollLeft += e.deltaY;
  };

  const exitSearchResult = (e) => {
    e.preventDefault();
    setVisibility(false);
    setQuery({ type: null, token: null });
  };

  let filtered = [];
  if (query.type == "name") {
    if (query.token === "") {
      filtered = [];
    } else if (query.token === "*") {
      filtered = members; // 테스트용
    } else {
      filtered = members.filter((member) => {
        if (!member.name | (member.name == "")) return false;
        else
          return (
            member.name.toLowerCase().indexOf(query.token.toLowerCase()) !== -1
          );
      });
    }
  } else if (query.type == "role") {
    filtered = members.filter(
      (member) => member.role.indexOf(query.token) !== -1
    );
  } else if (query.type == "id") {
    filtered = [members[query.token]]; //members.filter((member) => member.num == query.token);
  }

  if (!visibility) return;

  if (filtered.length > 0)
    return (
      <div>
        <div className="members__exit" />
        <div className="members" onWheel={(e) => onWheel(e)}>
          {filtered.map((member) => (
            <Member
              key={nanoid()}
              {...member}
              onWheel={(e) => onWheelChild(e)}
            />
          ))}
        </div>

        <div
          className="members__exit-button"
          onClick={(e) => exitSearchResult(e)}
        >
          {" "}
          Close All
        </div>
      </div>
    );
  // 검색 결과가 없는 경우, 키워드 입력을 요청
  else {
    setAlertMessage({ msg: "There is no result.", time: Date.now() });
    setVisibility(false);
  }
}
